/* eslint-disable max-len */
import { memo } from 'react';

function ArrowScrollToTop() {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 7L6 1L11 7"
        stroke="#707375"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(ArrowScrollToTop);
